import { defineStore } from 'pinia';
import { apolloClient } from '@/utils/apollo';
import { institutionQuery } from '@/graphql/queries/institution.js';
import { appConnectionsScreenQuery } from '@/graphql/queries/appConnectionsScreen.js';
import { useDepartmentStore } from '@/stores/department';
import { IDepartment, IInstitution } from '@/interfaces';

export const useInstitutionStore = defineStore('institution', {
  state: (): IInstitution => ({
    id: '',
    name: '',
    locale: '',
    logo: {
      source: '',
    },
    departments: [],
    availableDepartments: [],
    externalConnections: [],
    settings: null,
    didLoadExternalConnections: false,
    coverImage: {
      source: '',
    },
    colorHex: '',
    colorId: '',
  }),
  actions: {
    async getInstitution() {
      await apolloClient
        .query({
          query: institutionQuery,
        })
        .then((response) => {
          const departmentStore = useDepartmentStore();
          const availableDepartments = response.data.institution.departments
            .filter(
              ({ settings, loginKey, employeeOnly }: IDepartment) =>
                settings.screenConfig.departmentSwitcher &&
                !employeeOnly &&
                loginKey !== ''
            )
            .sort(
              (a: IDepartment, b: IDepartment) =>
                (b.id === departmentStore.id ? 1 : 0) -
                (a.id === departmentStore.id ? 1 : 0)
            );

          this.$patch({
            ...response.data.institution,
            availableDepartments,
          });
        })
        .catch((error) => {
          throw new Error('Error getting institution', error);
        });
    },
    async getExternalConnections() {
      await apolloClient
        .query({
          query: appConnectionsScreenQuery,
        })
        .then((response) => {
          this.externalConnections = response.data.appConnectionsScreen;
        })
        .catch((error) => {
          console.error('Error getting external connections', error);
        })
        .finally(() => {
          this.didLoadExternalConnections = true;

          const departmentStore = useDepartmentStore();
          departmentStore.checkIfValidExternalModule();
        });
    },
    isExternalInstitution(institutionId: string) {
      return this.id !== institutionId;
    },
  },
});
